import React from 'react';
import {
  Drawer,
  DrawerBody,
  DrawerHeader,
  Typography,
  Link,
} from '@one-thd/sui-atomic-components';
import { Store, QRCode as QRCodeIcon, BuyAgain } from '@one-thd/sui-icons';
import { SummaryShipment } from '@src/models/returns';
import PostSelectionItems from '../shared/items/PostSelectionItems';
import QRCode from '../shared/QR/QRCode';

interface SORISInstructionsDrawerProps {
  open: boolean;
  onClose: () => void;
  shipment?: SummaryShipment;
}

const SORISInstructionsDrawer = ({
  open,
  onClose,
  shipment,
}: SORISInstructionsDrawerProps) => {
  const { sorisId, sorisQRCode } = shipment || {};
  const imageSrc = `data:image/png;base64,${sorisQRCode}`;
  const shipmentItems = shipment?.itemsToReturn || [];

  return (
    <div className="sui-flex sui-flex-col sui-full sui-gap-4 sui-w-96">
      <Drawer
        open={open}
        onClose={onClose}
        position="right"
        className="drawer-z-index-fix"
      >
        <DrawerHeader title="In-Store Return QR Code" onClose={onClose} />
        <DrawerBody>
          <div className="sui-mb-4">
            <Typography>Return Items</Typography>
          </div>
          <PostSelectionItems selectedReturnItems={shipmentItems} />
          {imageSrc && (
            <div className="sui-mb-6 sui-flex sui-justify-center lg:sui-block lg:sui-ml-7">
              <QRCode imageSrc={imageSrc} sorisId={sorisId || ''} />
            </div>
          )}
          <div className="sui-mb-4 sui-flex sui-gap-3">
            <div className="sui-pt-[6px]">
              <Store />
            </div>
            <Typography>
              Take your return items to any{' '}
              <Link
                href="https://www.homedepot.com/l/storeDirectory"
                target="_blank"
              >
                Home Depot store
              </Link>
              .
            </Typography>
          </div>
          <div className="sui-mb-4 sui-flex sui-gap-3">
            <div className="sui-pt-[6px]">
              <QRCodeIcon />
            </div>
            <Typography>
              Show your QR code to an associate at the returns counter.
            </Typography>
          </div>
          <div className="sui-flex sui-gap-3">
            <div className="sui-pt-[6px]">
              <BuyAgain />
            </div>
            <Typography>
              It may take up to 10 business days for your bank to put the funds
              back into your account.
            </Typography>
          </div>
        </DrawerBody>
      </Drawer>
    </div>
  );
};

export default SORISInstructionsDrawer;
